import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col, Card, CardBody } from 'reactstrap'

import 'rc-slider/assets/index.css'

import { marketActions } from '../../../_actions'
import { Detail } from '../../../components/Admin/Dashboard'



export class Dashboard extends Component {

    state = {
        params: {
            city_id: 91890,
            currency: 'native',
        },
        accommodates: [1, 16],
        bedrooms: [1, 16],
        occupacity: [0, 100],
        properties: [],
        entire_home: "on",
        private_room: "on",
        shared_room: "on"
    }

    componentWillMount() {
        const { getAllProperties } = this.props
        const user = JSON.parse(localStorage.getItem('user'))
        let { params } = this.state

        params['access_token'] = user.token

        getAllProperties(params)
    }

    componentWillReceiveProps(nextProps, prevState) {
        const { markets } = nextProps
        const { properties } = this.state

        if (markets && markets.hasOwnProperty('properties') && markets.properties !== properties) {
            this.setState({ properties: markets.properties })
        }
    }

    handleOnChange = e => {
        const { name, value } = e.target
        this.setState({ [name]: value })
    }

    handleOnChangeBedrooms = e => {
        let { bedrooms } = this.state
        bedrooms = e
        this.setState({ bedrooms })
    }

    handleOnChangeAccommodates = e => {
        let { accommodates } = this.state
        accommodates = e
        this.setState({ accommodates })
    }

    handleOnChangeOccupacity = e => {
        let { occupacity } = this.state
        occupacity = e
        this.setState({ occupacity })
    }

    handleOnsubmit = e => {
        e.preventDefault()
        const { markets } = this.props
        const { accommodates, bedrooms, occupacity, entire_home, private_room, shared_room } = this.state

        // 0: "Entire home/apt"
        // 1: "Private room"
        // 2: "Shared room"

        let room_types = []

        if (entire_home === "on") {
            room_types.push("Entire home/apt")
        }
        if (private_room === "on") {
            room_types.push("Private room")
        }
        if (shared_room === "on") {
            room_types.push("Shared room")
        }

        const filteredProperties = markets.properties.filter(property =>
            property.accommodates >= accommodates[0] && property.accommodates <= accommodates[1] &&
            property.bedrooms >= bedrooms[0] && property.bedrooms <= bedrooms[1] &&
            property.occ >= occupacity[0] / 100 && property.occ <= occupacity[1] / 100 &&
            room_types.includes(property.room_type))

        this.setState({ properties: filteredProperties })
    }

    render() {
        const { accommodates, bedrooms, occupacity, properties } = this.state

        console.log(properties.length);


        return (
            <div className="page-content-wrapper">
                <div className="container-fluid">
                    <Detail
                        accommodates={accommodates}
                        bedrooms={bedrooms}
                        occupacity={occupacity}
                        onChange={this.handleOnChange}
                        onChangeAccommodates={this.handleOnChangeAccommodates}
                        onChangeBedrooms={this.handleOnChangeBedrooms}
                        onChangeOccupacity={this.handleOnChangeOccupacity}
                        onSubmit={this.handleOnsubmit}
                        properties={properties && properties.length ? properties : []}
                    />
                </div>
            </div>
        )
    }
}

const mapStatetoProps = state => {
    const { alert, authentication, markets } = state
    return {
        alert,
        user: authentication.user,
        markets,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        getAllProperties: params => dispatch(marketActions.getAllProperties(params))
    }
}

Dashboard = withRouter(connect(mapStatetoProps, mapDispatchToProps)(Dashboard))
